// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Per-user home page (file manager) and sign-in screen. Shares buttons, spinner, dialogs
   and the brand mark with components/pdf/PdfUpload.css. */

.home {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fb;
  color: #1f2937;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ── Header ── */
.home-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 24px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 5;
}
.home-search {
  flex: 1 1;
  max-width: 520px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  height: 40px;
  border-radius: 10px;
  background: #f1f3f4;
  color: #6b7280;
  transition: background 0.15s, box-shadow 0.15s;
}
.home-search:focus-within {
  background: #fff;
  box-shadow: 0 0 0 2px #1a73e8;
}
.home-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #1f2937;
}
.home-user {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.home-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a73e8, #6d4aff);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-user-name {
  font-size: 14px;
  font-weight: 600;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-link-btn {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  padding: 5px 10px;
  font-size: 12.5px;
  color: #374151;
  cursor: pointer;
}
.home-link-btn:hover {
  border-color: #1a73e8;
  color: #1a73e8;
}

/* ── Layout ── */
.home-body {
  flex: 1 1;
  display: flex;
  min-height: 0;
}
.home-nav {
  width: 220px;
  flex-shrink: 0;
  padding: 20px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.home-new-btn {
  margin-bottom: 14px;
  justify-content: flex-start;
}
.home-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
}
.home-nav-item:hover {
  background: #e8eaed;
}
.home-nav-item.is-active {
  background: #e8f0fe;
  color: #1a73e8;
  font-weight: 600;
}
.home-count {
  margin-left: auto;
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}
.home-nav-item.is-active .home-count {
  color: #1a73e8;
}
.home-main {
  flex: 1 1;
  min-width: 0;
  padding: 24px 28px 48px;
}
.home-section-head {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
}
.home-section-head h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}
.home-section-head span {
  font-size: 13px;
  color: #6b7280;
}
.home-placeholder {
  padding: 40px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  background: #fff;
}
.home-center {
  padding: 80px 0;
}
.home-error {
  margin-bottom: 16px;
  display: inline-block;
}

/* ── Workspace cards ── */
.home-ws-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}
.home-ws-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
  outline: none;
}
.home-ws-card:hover,
.home-ws-card:focus-visible {
  border-color: #1a73e8;
  box-shadow: 0 6px 20px rgba(26, 115, 232, 0.12);
  transform: translateY(-1px);
}
.home-ws-card.is-busy {
  opacity: 0.7;
  pointer-events: none;
}
.home-ws-top {
  display: flex;
  align-items: center;
  gap: 10px;
}
.home-ws-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #e8f0fe;
  color: #1a73e8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
}
.home-ws-title {
  flex: 1 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 650;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-rename {
  flex: 1 1;
  min-width: 0;
}
.home-rename input {
  width: 100%;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 8px;
  border: 1px solid #1a73e8;
  border-radius: 7px;
  outline: none;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);
}
.home-ws-spinner {
  color: #1a73e8;
  flex-shrink: 0;
}
.home-ws-files {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.home-ws-files li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  min-width: 0;
}
.home-ws-files li i {
  color: #dc2626;
  flex-shrink: 0;
}
.home-ws-files li span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-ws-more {
  color: #6b7280;
  padding-left: 22px;
}
.home-ws-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
  padding-top: 10px;
  border-top: 1px solid #f1f3f4;
}

/* ── Row menu ── */
.home-menu {
  position: relative;
  flex-shrink: 0;
}
.home-icon-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.home-icon-btn:hover {
  background: #f1f3f4;
  color: #1f2937;
}
.home-menu-list {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  min-width: 180px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  padding: 4px;
  z-index: 20;
  animation: pdfu-pop 0.12s ease-out;
}
.home-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: none;
  border-radius: 7px;
  background: transparent;
  font-size: 13.5px;
  color: #1f2937;
  cursor: pointer;
  text-align: left;
}
.home-menu-item:hover {
  background: #f3f4f6;
}
.home-menu-item.is-danger {
  color: #dc2626;
}
.home-menu-item.is-danger:hover {
  background: #fef2f2;
}

/* ── Files table ── */
.home-table {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: visible;
}
.home-table-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 100px 140px 44px;
  align-items: center;
  gap: 12px;
  padding: 10px 12px 10px 16px;
  border-top: 1px solid #f1f3f4;
  font-size: 14px;
  cursor: pointer;
  outline: none;
}
.home-table-row:not(.home-table-head):hover,
.home-table-row:not(.home-table-head):focus-visible {
  background: #f8faff;
}
.home-table-head {
  border-top: none;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  cursor: default;
}
.home-file-name {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  font-weight: 500;
}
.home-file-name i {
  color: #dc2626;
  font-size: 17px;
  flex-shrink: 0;
}
.home-file-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home-muted {
  color: #6b7280;
  font-size: 13px;
}
.home-row-actions {
  display: flex;
  justify-content: flex-end;
}

/* ── Empty state ── */
.home-empty {
  max-width: 560px;
  margin: 24px auto 0;
}
.home-empty-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06), 0 12px 40px rgba(16, 24, 40, 0.08);
}

/* ── Confirm dialog ── */
.home-confirm-text {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.55;
  color: #4b5563;
}
.home-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.home-btn-danger {
  background: #dc2626;
  color: #fff;
  min-width: 120px;
}
.home-btn-danger:hover:not(:disabled) {
  background: #b91c1c;
}

/* ── Opening overlay ── */
.home-opening {
  position: fixed;
  inset: 0;
  z-index: 10001;
  background: rgba(245, 247, 251, 0.85);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pdfu-fade 0.15s ease-out;
}

/* ── Sign-in ── */
.signin-hint {
  margin: 12px 0 0;
  font-size: 12.5px;
  color: #6b7280;
  line-height: 1.5;
}
.signin-hint code {
  background: #f1f3f4;
  padding: 1px 6px;
  border-radius: 5px;
  font-size: 12px;
  color: #1f2937;
  word-break: break-all;
}
.signin-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.signin-input {
  height: 46px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.signin-input:focus {
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);
}
.signin-continue {
  width: 100%;
  justify-content: space-between;
  background: #f8faff;
  border: 1px solid #c7d2e3;
  color: #1f2937;
}
.signin-continue:hover {
  border-color: #1a73e8;
}

/* ── Phone widths ── */
@media (max-width: 760px) {
  .home-header {
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 16px;
  }
  .home-search {
    order: 3;
    flex-basis: 100%;
    max-width: none;
  }
  .home-user {
    margin-left: auto;
  }
  .home-user-name {
    display: none;
  }
  .home-body {
    flex-direction: column;
  }
  .home-nav {
    width: auto;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 12px 16px 0;
  }
  .home-new-btn {
    flex-basis: 100%;
    justify-content: center;
    margin: 0 0 4px;
  }
  .home-nav-item {
    flex: 1 1;
    justify-content: center;
  }
  .home-count {
    margin-left: 4px;
  }
  .home-main {
    padding: 16px 16px 40px;
  }
  .home-table-row {
    grid-template-columns: minmax(0, 1fr) 44px;
  }
  .home-table-row > :nth-child(2),
  .home-table-row > :nth-child(3) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/HomePage.css"],"names":[],"mappings":"AAAA;0DAC0D;;AAE1D;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,8EAA8E;AAChF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iEAAiE;EACjE,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,aAAa;AACf;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gFAAgF;AAClF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,SAAO;IACP,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0CAA0C;EAC5C;EACA;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* Per-user home page (file manager) and sign-in screen. Shares buttons, spinner, dialogs\n   and the brand mark with components/pdf/PdfUpload.css. */\n\n.home {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #f5f7fb;\n  color: #1f2937;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* ── Header ── */\n.home-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 12px 24px;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 5;\n}\n.home-search {\n  flex: 1;\n  max-width: 520px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 14px;\n  height: 40px;\n  border-radius: 10px;\n  background: #f1f3f4;\n  color: #6b7280;\n  transition: background 0.15s, box-shadow 0.15s;\n}\n.home-search:focus-within {\n  background: #fff;\n  box-shadow: 0 0 0 2px #1a73e8;\n}\n.home-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  color: #1f2937;\n}\n.home-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.home-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1a73e8, #6d4aff);\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.home-user-name {\n  font-size: 14px;\n  font-weight: 600;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.home-link-btn {\n  border: 1px solid #d1d5db;\n  background: #fff;\n  border-radius: 8px;\n  padding: 5px 10px;\n  font-size: 12.5px;\n  color: #374151;\n  cursor: pointer;\n}\n.home-link-btn:hover {\n  border-color: #1a73e8;\n  color: #1a73e8;\n}\n\n/* ── Layout ── */\n.home-body {\n  flex: 1;\n  display: flex;\n  min-height: 0;\n}\n.home-nav {\n  width: 220px;\n  flex-shrink: 0;\n  padding: 20px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.home-new-btn {\n  margin-bottom: 14px;\n  justify-content: flex-start;\n}\n.home-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 12px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n}\n.home-nav-item:hover {\n  background: #e8eaed;\n}\n.home-nav-item.is-active {\n  background: #e8f0fe;\n  color: #1a73e8;\n  font-weight: 600;\n}\n.home-count {\n  margin-left: auto;\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n.home-nav-item.is-active .home-count {\n  color: #1a73e8;\n}\n.home-main {\n  flex: 1;\n  min-width: 0;\n  padding: 24px 28px 48px;\n}\n.home-section-head {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n.home-section-head h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n}\n.home-section-head span {\n  font-size: 13px;\n  color: #6b7280;\n}\n.home-placeholder {\n  padding: 40px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n  border: 1px dashed #d1d5db;\n  border-radius: 14px;\n  background: #fff;\n}\n.home-center {\n  padding: 80px 0;\n}\n.home-error {\n  margin-bottom: 16px;\n  display: inline-block;\n}\n\n/* ── Workspace cards ── */\n.home-ws-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n.home-ws-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 16px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n  outline: none;\n}\n.home-ws-card:hover,\n.home-ws-card:focus-visible {\n  border-color: #1a73e8;\n  box-shadow: 0 6px 20px rgba(26, 115, 232, 0.12);\n  transform: translateY(-1px);\n}\n.home-ws-card.is-busy {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.home-ws-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.home-ws-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #e8f0fe;\n  color: #1a73e8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 17px;\n  flex-shrink: 0;\n}\n.home-ws-title {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 650;\n  color: #111827;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.home-rename {\n  flex: 1;\n  min-width: 0;\n}\n.home-rename input {\n  width: 100%;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 5px 8px;\n  border: 1px solid #1a73e8;\n  border-radius: 7px;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);\n}\n.home-ws-spinner {\n  color: #1a73e8;\n  flex-shrink: 0;\n}\n.home-ws-files {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.home-ws-files li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #374151;\n  min-width: 0;\n}\n.home-ws-files li i {\n  color: #dc2626;\n  flex-shrink: 0;\n}\n.home-ws-files li span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.home-ws-more {\n  color: #6b7280;\n  padding-left: 22px;\n}\n.home-ws-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-size: 12px;\n  color: #6b7280;\n  padding-top: 10px;\n  border-top: 1px solid #f1f3f4;\n}\n\n/* ── Row menu ── */\n.home-menu {\n  position: relative;\n  flex-shrink: 0;\n}\n.home-icon-btn {\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n.home-icon-btn:hover {\n  background: #f1f3f4;\n  color: #1f2937;\n}\n.home-menu-list {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  min-width: 180px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n  padding: 4px;\n  z-index: 20;\n  animation: pdfu-pop 0.12s ease-out;\n}\n.home-menu-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 7px;\n  background: transparent;\n  font-size: 13.5px;\n  color: #1f2937;\n  cursor: pointer;\n  text-align: left;\n}\n.home-menu-item:hover {\n  background: #f3f4f6;\n}\n.home-menu-item.is-danger {\n  color: #dc2626;\n}\n.home-menu-item.is-danger:hover {\n  background: #fef2f2;\n}\n\n/* ── Files table ── */\n.home-table {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: visible;\n}\n.home-table-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 100px 140px 44px;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px 10px 16px;\n  border-top: 1px solid #f1f3f4;\n  font-size: 14px;\n  cursor: pointer;\n  outline: none;\n}\n.home-table-row:not(.home-table-head):hover,\n.home-table-row:not(.home-table-head):focus-visible {\n  background: #f8faff;\n}\n.home-table-head {\n  border-top: none;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  cursor: default;\n}\n.home-file-name {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  font-weight: 500;\n}\n.home-file-name i {\n  color: #dc2626;\n  font-size: 17px;\n  flex-shrink: 0;\n}\n.home-file-name span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.home-muted {\n  color: #6b7280;\n  font-size: 13px;\n}\n.home-row-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* ── Empty state ── */\n.home-empty {\n  max-width: 560px;\n  margin: 24px auto 0;\n}\n.home-empty-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 24px;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06), 0 12px 40px rgba(16, 24, 40, 0.08);\n}\n\n/* ── Confirm dialog ── */\n.home-confirm-text {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #4b5563;\n}\n.home-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.home-btn-danger {\n  background: #dc2626;\n  color: #fff;\n  min-width: 120px;\n}\n.home-btn-danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n/* ── Opening overlay ── */\n.home-opening {\n  position: fixed;\n  inset: 0;\n  z-index: 10001;\n  background: rgba(245, 247, 251, 0.85);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: pdfu-fade 0.15s ease-out;\n}\n\n/* ── Sign-in ── */\n.signin-hint {\n  margin: 12px 0 0;\n  font-size: 12.5px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n.signin-hint code {\n  background: #f1f3f4;\n  padding: 1px 6px;\n  border-radius: 5px;\n  font-size: 12px;\n  color: #1f2937;\n  word-break: break-all;\n}\n.signin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.signin-input {\n  height: 46px;\n  padding: 0 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n.signin-input:focus {\n  border-color: #1a73e8;\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.15);\n}\n.signin-continue {\n  width: 100%;\n  justify-content: space-between;\n  background: #f8faff;\n  border: 1px solid #c7d2e3;\n  color: #1f2937;\n}\n.signin-continue:hover {\n  border-color: #1a73e8;\n}\n\n/* ── Phone widths ── */\n@media (max-width: 760px) {\n  .home-header {\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 10px 16px;\n  }\n  .home-search {\n    order: 3;\n    flex-basis: 100%;\n    max-width: none;\n  }\n  .home-user {\n    margin-left: auto;\n  }\n  .home-user-name {\n    display: none;\n  }\n  .home-body {\n    flex-direction: column;\n  }\n  .home-nav {\n    width: auto;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    padding: 12px 16px 0;\n  }\n  .home-new-btn {\n    flex-basis: 100%;\n    justify-content: center;\n    margin: 0 0 4px;\n  }\n  .home-nav-item {\n    flex: 1;\n    justify-content: center;\n  }\n  .home-count {\n    margin-left: 4px;\n  }\n  .home-main {\n    padding: 16px 16px 40px;\n  }\n  .home-table-row {\n    grid-template-columns: minmax(0, 1fr) 44px;\n  }\n  .home-table-row > :nth-child(2),\n  .home-table-row > :nth-child(3) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
